import { Skeleton } from '@chakra-ui/react'

export function TableSkeleton() {
  return <Skeleton w='100%' h='500px' borderRadius='16px' />
}
